<template>
	<l-map v-model="zoom" v-model:zoom="zoom" :center="coordinates" :options="options">
		<l-tile-layer :url="url" :attribution="attribution" />
		<l-marker :lat-lng="coordinates" draggable @moveend="$emit('coordinatesChosen', $event.target._latlng)" />
	</l-map>
</template>

<script>
	import { LMap, LTileLayer, LMarker } from '@vue-leaflet/vue-leaflet';
	import 'leaflet/dist/leaflet.css';
	import { cartoLightSource, mapAttribution } from '@/constants/mapTiles';

	export default {
		name: 'AppMapPicker',
		props: ['coordinates'],
		emits: ['coordinatesChosen'],
		components: { LMap, LTileLayer, LMarker },
		data: () => ({
			url: cartoLightSource,
			attribution: mapAttribution,
			zoom: 17,
			options: {
				zoomControl: false,
			},
		}),
	};
</script>
